import React from 'react';
import styled from 'styled-components';
import {CreateQuizSize} from '../Sizes';
import {Mobile,Default} from '../Sizes';
import {SurfaceColor,DividerColor} from '../Colors';

const style = {
	Wrapper : styled.div`
		display : flex;
		justify-content : center;
		background-color : ${SurfaceColor};
	`,
	LeftSide : styled.div`
		position : relative;
		width : ${CreateQuizSize.RecipeListWidth};
		height : ${CreateQuizSize.Height};
		border-right : 0.5px dotted ${DividerColor};
		padding : 1rem;
	`,
	RightSide : styled.div`
		width : ${CreateQuizSize.QuizListWidth};
		height : ${CreateQuizSize.Height};
		padding : 1rem;
	`,
	mobile : {
		Wrapper : styled.div`
			background-color : ${SurfaceColor};
		`,
		RightSide : styled.div`
			width : 100%;
		`
	}
};



export default function RecipeAndQuizLayout({renderLeft,renderRight,...props}){
	return (
		<React.Fragment>
			<Default>
				<style.Wrapper {...props}>
					<style.LeftSide>
						{renderLeft()}
					</style.LeftSide>
					<style.RightSide>
						{renderRight()}
					</style.RightSide>
				</style.Wrapper>
			</Default>
			<Mobile>
				<style.mobile.Wrapper>
					<style.mobile.RightSide>
						{renderRight()}
					</style.mobile.RightSide>
				</style.mobile.Wrapper>
			</Mobile>
		</React.Fragment>
		
	);
}
